import { IconButton } from '@material-ui/core';
import { GridRowData } from '@material-ui/data-grid';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import en from '../../../../lang/en-us';
import { SubmitButton } from '../../../../lib/Button';
import { TableColumn, TableCellParams, TableWithCollapse } from '../../../../lib/DataTable';
import { fetchInvestorDetails } from '../../../../redux-store/actions/nct';
import { getPortfolio } from '../../../../redux-store/actions/portfolio';
import { RootStateType } from '../../../../redux-store/reducers';
import { INVESTOR_OBJECT } from '../../../../redux-store/types/nct';
import { LIST_PROTFOLIO_PAYLOAD } from '../../../../redux-store/types/portfolio';
import {
    getErrorMessage,
    getInvestorFunds,
    minorBelowEighteenYears,
    modeOfHoldingSingle,
    notLockedFolio,
    portfoliosByMinorStatus,
    portfoliosByTransactionResource,
} from '../../portfolios/utils';
import { NomineeInfoRowData } from './types';
import { EQUITY, LIQUID, DEBT, OTHER, UPDATE_NOMINEE } from './../../../../utils/constants';
import NoFoliosFound from '../NoFoliosFound';
import { useTableWithCollapse } from '../../../../lib/DataTable/customHooks';
import { ActionHeader, FaqLink } from '..';
import { getMatchAndUnMatchedFunds } from '../../../../utils/utilityFunctions';

const { dashboard } = en;

const _renderNominee = ({ row, setCollapse, collapse }: TableCellParams) => {
    return (
        <>
            {row.nominees.length ? (
                <>
                    <span>Yes</span>
                    <IconButton
                        className="update-nominee-collapse-btn"
                        aria-label="expand row"
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            setCollapse((open: boolean) => !open);
                        }}
                    >
                        {!collapse ? (
                            <>
                                <span>View</span>
                                <KeyboardArrowDown />
                            </>
                        ) : (
                            <>
                                <span>Hide</span>
                                <KeyboardArrowUp />
                            </>
                        )}
                    </IconButton>
                </>
            ) : (
                <span>No</span>
            )}
        </>
    );
};

const Columns: TableColumn[] = [
    {
        field: 'id',
        headerName: 'FOLIO',
    },
    {
        field: 'amcName',
        headerName: 'Fund House',
        width: 350,
        filterBy: true,
    },
    {
        field: 'investorName',
        headerName: 'PRIMARY HOLDER',
        width: 300,
    },
    {
        field: 'nominees',
        renderCell: _renderNominee,
        headerName: 'NOMINEE Details',
        width: 150,
    },
    {
        isFilter: true,
        field: 'assetType',
        headerName: 'Category',
        filterBy: true,
        renderStaticFilters: [EQUITY, LIQUID, DEBT, OTHER],
    },
];

function Nominee(props: any) {
    const [rowData, setRowData] = useState<NomineeInfoRowData[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const { selectedRows, setSelectedRows, tableColumns, tableRows, ...filters } =
        useTableWithCollapse<NomineeInfoRowData[]>({ rows: rowData, columns: Columns, loading });
    const { userRegisteredWith } = props;

    useEffect(() => {
        setLoading(true);
        async function callApi() {
            const payload: LIST_PROTFOLIO_PAYLOAD = {
                pan: props.pan,
                mobile: props.mobile,
                pekrn: props.pekrn,
                reqId: props.reqId,
            };
            try {
                await props.getPortfolio(payload);
                const { body: investorDetails = {} } = await props.fetchInvestorDetails(payload);
                const { success: nomineeFunds = [] } = investorDetails;
                const funds = getInvestorFunds(
                    nomineeFunds,
                    [portfoliosByTransactionResource],
                    [portfoliosByMinorStatus],
                );
                const data = getMatchAndUnMatchedFunds(
                    [
                        notLockedFolio,
                        modeOfHoldingSingle,
                        // ({ emailRelationship, mobileRelationship }: INVESTOR_OBJECT) => {
                        //     if (userRegisteredWith === 'MOBILE') {
                        //         return !!mobileRelationship;
                        //     }
                        //     return !!emailRelationship;
                        // },
                    ],
                    funds,
                    true,
                );

                const { nomineeFunds: _nomineeFunds = [], otherFunds = [] } = data.reduce(
                    (prev: any, fund: NomineeInfoRowData) => {
                        if (fund?.nominees?.length) {
                            return { ...prev, nomineeFunds: [...(prev.nomineeFunds ?? []), fund] };
                        }
                        return { ...prev, otherFunds: [...(prev.otherFunds ?? []), fund] };
                    },
                    [],
                );
                setRowData([...otherFunds, ..._nomineeFunds]);
                setLoading(false);
            } catch (err: any) {
                alert(err.message);
            }
        }
        callApi();
        return () => { };
    }, []);

    const _rederCollapse = ({ row }: { row: GridRowData }) => {
        const { nominees = [] } = row;
        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'row',
                    width: '100%',
                    flexWrap: 'wrap',
                }}
            >
                {new Array(3).fill('').map((_, index) => (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            marginRight: 150,
                        }}
                    >
                        <label>Nominee {index + 1}</label>
                        <label>{nominees[index] ? nominees[index].name : 'N/A'}</label>
                    </div>
                ))}
            </div>
        );
    };

    const TableBody = useMemo(() => {
        return (
            <TableWithCollapse
                renderCollapse={_rederCollapse}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                columns={tableColumns}
                rows={tableRows}
                toolTipTextGetter={({ row }) =>
                    getErrorMessage(row, [notLockedFolio, modeOfHoldingSingle])
                }
                isRowSelectable={({ row }) => (row.isDisabled ? false : true)}
                radioGroupsEnabled
                toolTipEnabled
                {...filters}
            />
        );
    }, [tableColumns, tableRows, selectedRows, filters]);

    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.UpdateNominee.UpdateNomineeHeading} />
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table">
                    <h5> {dashboard.UpdateNominee.UpdateNomineeInfo}</h5>
                    <div className="curved-table-content">
                        {loading || rowData.length ? (
                            TableBody
                        ) : (
                            <NoFoliosFound info={dashboard.UpdateNominee.EmptyNomineeInfo} />
                        )}
                    </div>
                    <FaqLink section={UPDATE_NOMINEE} history={props.history} />
                </div>
                <div className="curved-bg-content-inner-bottom">
                    <div className="table-submit">
                        <SubmitButton
                            onClick={() =>
                                props.history.push('/portal/nct/update-nominee-edit', {
                                    nomineesData: selectedRows[0],
                                })
                            }
                            className="customBtn"
                            disabled={!selectedRows.length}
                            label={dashboard.UpdateNominee.buttonNext}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    { getPortfolio, fetchInvestorDetails },
)(Nominee);
